import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('profile', 'remove-account');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'fitness_tracking',
  type: 'delete',
  slug: [
    'provider_authentications',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/remove-account.js